<template>
  <div class="index">
    <div class="index" v-if="showPage">
      <ranking-table
        :results="this.results"
        @scrolledToBottom="fetchEntries()"
      ></ranking-table>

      <div v-bind:class="this.overlay_class">
        <div
          v-if="this.shouldShowViewindUserEntry"
          class="overlay__viewingUser"
        >
          <ranking-cell
            :result="this.viewingUserEntry"
            :overlay="true"
          ></ranking-cell>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import APIRequest from '@/utils/APIRequest'
import RankingTable from '@/components/Games/RankingTable.vue'
import RankingCell from '@/components/Games/RankingCell.vue'
import { getToken } from '@/utils/token'
import i18n from '@/i18n'

export default {
  components: {
    RankingTable,
    RankingCell,
  },
  title: i18n.t('gameRankingTitle'),
  name: 'GamePeriodRanking',
  data: function () {
    return {
      results: [],
      next: 1,
      periodId: this.$route.params.periodId,
      current: undefined,
      shouldShowAlert: false,
      alertContent: {},
      viewingUserEntry: undefined,
      overlay_class: 'overlay',
      token: undefined,
    }
  },
  computed: {
    showPage: function () {
      return this.current !== undefined
    },
    shouldShowViewindUserEntry: function () {
      return this.viewingUserEntry !== undefined
    },
  },
  created() {
    this.token = this.getToken()
    this.fetchGamePeriod()
    this.allowScrolling(true)

    let ua = window.navigator.userAgent
    if (ua.indexOf('iPhone OS') > 0) {
      let version = ua.match(/iPhone OS ([\d]+)/)
      let major = version ? version[1] : 0
      if (major >= 13) {
        this.overlay_class = 'overlay__iOS_SM'
      }
    }
  },
  methods: {
    handleTouchMove: function (e) {
      e.preventDefault()
    },
    getToken() {
      return getToken()
    },
    allowScrolling: function (val) {
      if (val) {
        document.body.className = 'body__scrolling'
        document.ontouchmove = () => true
      } else {
        document.body.className = 'body__nonscrolling'
        document.ontouchmove = (e) => e.preventDefault()
      }
    },
    fetchGamePeriod: async function () {
      const response = await this.$loader.post(
        new APIRequest(
          this.$config.appGatewayServerUrl,
          '/game/period/get',
          {
            periodId: this.periodId,
          },
          {
            Authorization: `Bearer ${this.getToken()}`,
          }
        )
      )

      const period = response.period
      this.current = period
      this.fetchEntries()
      this.fetchEntryWithVliveId()
    },
    fetchEntryWithVliveId: async function () {
      if (this.current === undefined) {
        return
      }
      //tokenが空の時はリクエストしない
      if (this.getToken() === undefined) {
        return
      }
      const response = await this.$loader.post(
        new APIRequest(
          this.$config.appGatewayServerUrl,
          '/game/leaderboard/entry/get',
          {
            gameId: this.current.gameId,
            periodId: this.periodId,
            name: 'score',
          },
          {
            Authorization: `Bearer ${this.getToken()}`,
          }
        )
      )

      if (response.entry.score > 0) {
        this.viewingUserEntry = response.entry
      }
    },
    fetchEntries: async function () {
      if (this.current === undefined) {
        return
      }

      if (this.next == 0) {
        // nextが0になったら終わり
        return
      }
      const response = await this.$loader.post(
        new APIRequest(
          this.$config.appGatewayServerUrl,
          '/game/leaderboard/entry/list',
          {
            gameId: this.current.gameId,
            periodId: this.periodId,
            name: 'score',
            page: this.next,
          },
          {
            Authorization: `Bearer ${this.getToken()}`,
          }
        )
      )

      const entries = response.entries
      const page = response.pagination

      this.results = this.results.concat(entries)
      this.next = page.next
    },
  },
}
</script>

<style scoped>
.index {
  height: 100%;
  min-height: 850px;
}

.overlay {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.overlay__iOS_SM {
  position: fixed;
  bottom: 34px;
  width: 100%;
}
.overlay__viewingUser {
  width: 100%;
  height: 93px;
  background-color: #188dff;
}
</style>
